export default {
  'suppliers.searchBar.button': 'Criar Novo Fornecedor',
  'suppliers.searchBar.generateReport': 'Gerar Relatório',
  'suppliers.list.header.cpfCnpj': 'CPF/CNPJ',
  'suppliers.list.header.name': 'Nome',
  'suppliers.list.header.email': 'E-mail',
  'suppliers.list.header.contact': 'Contato',
  'suppliers.list.header.phone': 'Telefone',
  'suppliers.list.header.actions': 'Ações',
  'suppliers.list.column.actions.button': 'Ver/Editar',
  'suppliers.filters.active': 'Ativo',
  'suppliers.filters.active.options.all': 'Todos',
  'suppliers.filters.active.options.active': 'Ativo',
  'suppliers.filters.active.options.inactive': 'Inativo',
  'suppliers.filters.cpfCnpj': 'CPF/CNPJ',
  'suppliers.filters.product': 'Produto',
  'suppliers.filters.nickName': 'Nome Fantasia',
  'suppliers.filters.order': 'Ordenar por',
  'suppliers.filters.order.options.asc': 'Ascendente',
  'suppliers.filters.order.options.desc': 'Descendente',

  'suppliers.modal.report.title': 'Gerar Relatório',
  'suppliers.modal.report.buttons.viewReport': 'Visualizar Relatório',
  'suppliers.modal.report.buttons.pdf': 'Gerar PDF',
  'suppliers.modal.report.buttons.rtf': 'Gerar RTF',
  'suppliers.modal.report.buttons.csv': 'Gerar CSV',
  'suppliers.modal.report.form.type': 'Tipo',
  'suppliers.modal.report.form.situation': 'Situação',
  'suppliers.modal.report.form.state': 'UF',
  'suppliers.modal.report.form.city': 'Cidade',
  'suppliers.modal.report.form.pieces': 'Linha de peças',

  'suppliers.notification.generate.report.title':
    'Relatório gerado com sucesso',
  'suppliers.notification.generate.report.description':
    'Relatório de Fornecedor Gerado com Sucesso!',

  'suppliers.general.form.name': 'Nome',
  'suppliers.general.form.type': 'Tipo',
  'suppliers.general.form.type.individual': 'Pessoa Física',
  'suppliers.general.form.type.legalPerson': 'Pessoa Jurídica',
  'suppliers.general.form.cnpj': 'CNPJ',
  'suppliers.general.form.nickName': 'Nome Fantasia',
  'suppliers.general.form.stateRegistration': 'Incrição Estadual',
  'suppliers.general.form.municipalRegistration': 'Incrição Municipal',
  'suppliers.general.form.classification': 'Classificação',
  'suppliers.general.form.classification.dealership': 'Concessionária',
  'suppliers.general.form.classification.distributor': 'Distribuidor',
  'suppliers.general.form.classification.retail': 'Varejo',
  'suppliers.general.form.classification.wholesale': 'Atacarejo',
  'suppliers.general.form.classification.others': 'Outros',
  'suppliers.general.form.email': 'E-mail',
  'suppliers.general.form.webSite': 'Web Site',
  'suppliers.general.form.note': 'Observações',
  'suppliers.general.form.situation': 'Situação',
  'suppliers.general.form.situation.active': 'Ativo',
  'suppliers.general.form.situation.inactive': 'Inativo',
  'suppliers.general.form.product': 'Linha de peças',
  'suppliers.general.form.telephones': 'Telefones',
  'suppliers.general.form.phoneCompany': 'Operadora',
  'suppliers.general.form.newContact': 'Novo Contato',

  'suppliers.general.form.planAccount': 'Plano de Contas',
  'supplier.modal.button.saveAddress': 'Salvar endereço',

  'suppliers.notifications.create.success.title':
    'Fornecedor cadastrado com sucesso!',
  'suppliers.notifications.create.success.description':
    'O novo fornecedor foi cadastrado com êxito.',

  'suppliers.notifications.update.success.title': 'Sucesso',
  'suppliers.notifications.update.success.description':
    'Dados do fornecedor atualizado com sucesso!',

  'suppliers.activate.message.success': 'Fornecedor Ativado com Sucesso!',
  'suppliers.inactivate.message.success': 'Fornecedor Inativado com Sucesso!',

  'suppliers.remove': 'Remover Fornecedor',
  'suppliers.remove.modal.content': 'Deseja realmente remover o Fornecedor?',
  'suppliers.remove.modal.button.ok': 'Remover',
  'suppliers.remove.notification.success': 'Fornecedor Removido',
  'suppliers.remove.notification.successDescription':
    'Fornecedor foi removido com sucesso',

  'suppliers.address.create.notification.success': 'Sucesso',
  'suppliers.address.create.notification.successDescription':
    'Endereço criado.',

  'suppliers.contacts.remove': 'Remover Contato',
  'suppliers.contacts.remove.alert': 'Você realmente deseja remover o contato:',

  'suppliers.address.update.notification.success': 'Sucesso',
  'suppliers.address.update.notification.successDescription':
    'Endereço atualizado.',

  'suppliers.address.remove': 'Remover Endereço',
  'suppliers.address.remove.alert': 'Você realmente deseja remover o endereço:',
  'suppliers.address.remove.notification.success': 'Sucesso',
  'suppliers.address.remove.notification.successDescription':
    'Endereço removido.',

  'suppliers.column.address.zipCode': 'CEP',
  'suppliers.column.address.street': 'Logradouro',
  'suppliers.column.address.complement': 'Complemento',
  'suppliers.modal.selectedSuppliers.title.add': 'Adicionar Fornecedor',
  'suppliers.modal.selectedSuppliers.search': 'Busque os Fornecedores',
};
